import { clsx } from 'clsx';
import { getFightingStylesForClass, getFightingStyle } from '@character-creator/data';

interface FightingStyleSelectorProps {
  classId: 'fighter' | 'paladin' | 'ranger';
  selectedStyleId: string | null;
  onSelect: (styleId: string | null) => void;
  compact?: boolean;
}

export function FightingStyleSelector({
  classId,
  selectedStyleId,
  onSelect,
  compact = false,
}: FightingStyleSelectorProps) {
  const availableStyles = getFightingStylesForClass(classId);
  const selectedStyle = selectedStyleId ? getFightingStyle(selectedStyleId) : null;

  // Compact view - shows selected style with change option
  if (compact && selectedStyle) {
    return (
      <div className="text-xs text-success flex items-center gap-1">
        <span>Fighting Style: {selectedStyle.name}</span>
        <button
          type="button"
          onClick={() => onSelect(null)}
          className="ml-2 text-text-muted hover:text-error transition-colors"
        >
          (change)
        </button>
      </div>
    );
  }

  return (
    <div>
      <h5 className="text-sm font-medium text-text-primary mb-2">
        Fighting Style
        {!selectedStyleId && (
          <span className="text-warning ml-2 text-xs">(Required)</span>
        )}
      </h5>
      <div className="grid grid-cols-1 gap-2">
        {availableStyles.map((style) => (
          <button
            key={style.id}
            type="button"
            onClick={() => onSelect(style.id)}
            className={clsx(
              'w-full text-left p-3 rounded-lg border transition-all duration-200',
              selectedStyleId === style.id
                ? 'bg-accent-gold/10 border-accent-gold'
                : 'bg-background-secondary border-background-elevated hover:border-text-muted'
            )}
          >
            <div className="font-medium text-text-primary text-sm">{style.name}</div>
            <p className="text-xs text-text-secondary mt-1">{style.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
